"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/cms_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSEventServiceUpdateEventTicketsPriorityResponse = exports.CMSEventServiceUpdateEventTicketsPriorityRequest = exports.TicketPriority = exports.CMSEventServiceGetOwnedEventsResponse = exports.CMSEventServiceGetOwnedEventsRequest = exports.CMSEventServiceGetEventResponse = exports.CMSEventServiceGetEventRequest = exports.CMSEventServiceUpdateEventResponse = exports.CMSEventServiceUpdateEventRequest = exports.CMSEventServiceDraftEventResponse = exports.CMSEventServiceDraftEventRequest = exports.CMSEventServiceSaveEventResponse = exports.CMSEventServiceSaveEventRequest = exports.CMSEventServiceGetOwnedEventTicketSalesResponse = exports.CMSEventServiceGetOwnedEventTicketSalesRequest = exports.CMSEventServiceGetEventTicketSalesByEventIdResponse = exports.CMSEventServiceGetEventTicketSalesByEventIdRequest = exports.CMSEventServiceGetEventTicketsByEventIdResponse = exports.CMSEventServiceGetEventTicketsByEventIdRequest = exports.CMSEventServiceUpdateEventTicketsResponse = exports.CMSEventServiceUpdateEventTicketsRequest = exports.CMSEventServiceUpdateEventTicketRequest = exports.CMSEventServiceCreateEventTicketsResponse = exports.CMSEventServiceCreateEventTicketsRequest = exports.CMSEventServiceCreateEventTicketRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const cms_common_pb_1 = require("./cms_common_pb");
/**
 * @generated from message spwn.event.v1.CMSEventServiceCreateEventTicketRequest
 */
class CMSEventServiceCreateEventTicketRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * イベントタイトル
         *
         * @generated from field: string event_title = 2;
         */
        this.eventTitle = "";
        /**
         * チケット情報.チケット名
         *
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * チケット情報.価格
         *
         * @generated from field: double price_jpy = 4;
         */
        this.priceJpy = 0;
        /**
         * 日時設定.販売開始日時
         *
         * @generated from field: int64 release_date_time = 5;
         */
        this.releaseDateTime = protobuf_1.protoInt64.zero;
        /**
         * 日時設定.販売終了日時
         *
         * @generated from field: int64 close_date_time = 6;
         */
        this.closeDateTime = protobuf_1.protoInt64.zero;
        /**
         * チケット情報.チケット説明文
         *
         * @generated from field: string description = 7;
         */
        this.description = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceCreateEventTicketRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceCreateEventTicketRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceCreateEventTicketRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceCreateEventTicketRequest, a, b);
    }
}
exports.CMSEventServiceCreateEventTicketRequest = CMSEventServiceCreateEventTicketRequest;
CMSEventServiceCreateEventTicketRequest.runtime = protobuf_1.proto3;
CMSEventServiceCreateEventTicketRequest.typeName = "spwn.event.v1.CMSEventServiceCreateEventTicketRequest";
CMSEventServiceCreateEventTicketRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price_jpy", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "release_date_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "close_date_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceCreateEventTicketsRequest
 */
class CMSEventServiceCreateEventTicketsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.CMSEventServiceCreateEventTicketRequest tickets = 1;
         */
        this.tickets = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceCreateEventTicketsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceCreateEventTicketsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceCreateEventTicketsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceCreateEventTicketsRequest, a, b);
    }
}
exports.CMSEventServiceCreateEventTicketsRequest = CMSEventServiceCreateEventTicketsRequest;
CMSEventServiceCreateEventTicketsRequest.runtime = protobuf_1.proto3;
CMSEventServiceCreateEventTicketsRequest.typeName = "spwn.event.v1.CMSEventServiceCreateEventTicketsRequest";
CMSEventServiceCreateEventTicketsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tickets", kind: "message", T: CMSEventServiceCreateEventTicketRequest, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceCreateEventTicketsResponse
 */
class CMSEventServiceCreateEventTicketsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.EventTicket tickets = 1;
         */
        this.tickets = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceCreateEventTicketsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceCreateEventTicketsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceCreateEventTicketsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceCreateEventTicketsResponse, a, b);
    }
}
exports.CMSEventServiceCreateEventTicketsResponse = CMSEventServiceCreateEventTicketsResponse;
CMSEventServiceCreateEventTicketsResponse.runtime = protobuf_1.proto3;
CMSEventServiceCreateEventTicketsResponse.typeName = "spwn.event.v1.CMSEventServiceCreateEventTicketsResponse";
CMSEventServiceCreateEventTicketsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tickets", kind: "message", T: cms_common_pb_1.EventTicket, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceUpdateEventTicketRequest
 */
class CMSEventServiceUpdateEventTicketRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * チケットID
         *
         * @generated from field: string ticket_id = 1;
         */
        this.ticketId = "";
        /**
         * イベントID
         *
         * @generated from field: string event_id = 2;
         */
        this.eventId = "";
        /**
         * イベントタイトル
         *
         * @generated from field: string event_title = 3;
         */
        this.eventTitle = "";
        /**
         * チケット情報.チケット説明文
         *
         * @generated from field: string description = 4;
         */
        this.description = "";
        /**
         * チケット情報.チケット名
         *
         * @generated from field: string name = 5;
         */
        this.name = "";
        /**
         * 日時設定.販売開始日時
         *
         * @generated from field: int64 release_date_time = 6;
         */
        this.releaseDateTime = protobuf_1.protoInt64.zero;
        /**
         * 日時設定.販売終了日時
         *
         * @generated from field: int64 close_date_time = 7;
         */
        this.closeDateTime = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceUpdateEventTicketRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceUpdateEventTicketRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceUpdateEventTicketRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceUpdateEventTicketRequest, a, b);
    }
}
exports.CMSEventServiceUpdateEventTicketRequest = CMSEventServiceUpdateEventTicketRequest;
CMSEventServiceUpdateEventTicketRequest.runtime = protobuf_1.proto3;
CMSEventServiceUpdateEventTicketRequest.typeName = "spwn.event.v1.CMSEventServiceUpdateEventTicketRequest";
CMSEventServiceUpdateEventTicketRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "release_date_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "close_date_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceUpdateEventTicketsRequest
 */
class CMSEventServiceUpdateEventTicketsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.CMSEventServiceUpdateEventTicketRequest tickets = 1;
         */
        this.tickets = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceUpdateEventTicketsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceUpdateEventTicketsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceUpdateEventTicketsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceUpdateEventTicketsRequest, a, b);
    }
}
exports.CMSEventServiceUpdateEventTicketsRequest = CMSEventServiceUpdateEventTicketsRequest;
CMSEventServiceUpdateEventTicketsRequest.runtime = protobuf_1.proto3;
CMSEventServiceUpdateEventTicketsRequest.typeName = "spwn.event.v1.CMSEventServiceUpdateEventTicketsRequest";
CMSEventServiceUpdateEventTicketsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tickets", kind: "message", T: CMSEventServiceUpdateEventTicketRequest, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceUpdateEventTicketsResponse
 */
class CMSEventServiceUpdateEventTicketsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.EventTicket tickets = 1;
         */
        this.tickets = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceUpdateEventTicketsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceUpdateEventTicketsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceUpdateEventTicketsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceUpdateEventTicketsResponse, a, b);
    }
}
exports.CMSEventServiceUpdateEventTicketsResponse = CMSEventServiceUpdateEventTicketsResponse;
CMSEventServiceUpdateEventTicketsResponse.runtime = protobuf_1.proto3;
CMSEventServiceUpdateEventTicketsResponse.typeName = "spwn.event.v1.CMSEventServiceUpdateEventTicketsResponse";
CMSEventServiceUpdateEventTicketsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tickets", kind: "message", T: cms_common_pb_1.EventTicket, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceGetEventTicketsByEventIdRequest
 */
class CMSEventServiceGetEventTicketsByEventIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceGetEventTicketsByEventIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceGetEventTicketsByEventIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceGetEventTicketsByEventIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceGetEventTicketsByEventIdRequest, a, b);
    }
}
exports.CMSEventServiceGetEventTicketsByEventIdRequest = CMSEventServiceGetEventTicketsByEventIdRequest;
CMSEventServiceGetEventTicketsByEventIdRequest.runtime = protobuf_1.proto3;
CMSEventServiceGetEventTicketsByEventIdRequest.typeName = "spwn.event.v1.CMSEventServiceGetEventTicketsByEventIdRequest";
CMSEventServiceGetEventTicketsByEventIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceGetEventTicketsByEventIdResponse
 */
class CMSEventServiceGetEventTicketsByEventIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.EventTicket tickets = 1;
         */
        this.tickets = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceGetEventTicketsByEventIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceGetEventTicketsByEventIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceGetEventTicketsByEventIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceGetEventTicketsByEventIdResponse, a, b);
    }
}
exports.CMSEventServiceGetEventTicketsByEventIdResponse = CMSEventServiceGetEventTicketsByEventIdResponse;
CMSEventServiceGetEventTicketsByEventIdResponse.runtime = protobuf_1.proto3;
CMSEventServiceGetEventTicketsByEventIdResponse.typeName = "spwn.event.v1.CMSEventServiceGetEventTicketsByEventIdResponse";
CMSEventServiceGetEventTicketsByEventIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tickets", kind: "message", T: cms_common_pb_1.EventTicket, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceGetEventTicketSalesByEventIdRequest
 */
class CMSEventServiceGetEventTicketSalesByEventIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_firestore_id = 1;
         */
        this.eventFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceGetEventTicketSalesByEventIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceGetEventTicketSalesByEventIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceGetEventTicketSalesByEventIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceGetEventTicketSalesByEventIdRequest, a, b);
    }
}
exports.CMSEventServiceGetEventTicketSalesByEventIdRequest = CMSEventServiceGetEventTicketSalesByEventIdRequest;
CMSEventServiceGetEventTicketSalesByEventIdRequest.runtime = protobuf_1.proto3;
CMSEventServiceGetEventTicketSalesByEventIdRequest.typeName = "spwn.event.v1.CMSEventServiceGetEventTicketSalesByEventIdRequest";
CMSEventServiceGetEventTicketSalesByEventIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceGetEventTicketSalesByEventIdResponse
 */
class CMSEventServiceGetEventTicketSalesByEventIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.CMSEventTicketSales sales = 1;
         */
        this.sales = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceGetEventTicketSalesByEventIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceGetEventTicketSalesByEventIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceGetEventTicketSalesByEventIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceGetEventTicketSalesByEventIdResponse, a, b);
    }
}
exports.CMSEventServiceGetEventTicketSalesByEventIdResponse = CMSEventServiceGetEventTicketSalesByEventIdResponse;
CMSEventServiceGetEventTicketSalesByEventIdResponse.runtime = protobuf_1.proto3;
CMSEventServiceGetEventTicketSalesByEventIdResponse.typeName = "spwn.event.v1.CMSEventServiceGetEventTicketSalesByEventIdResponse";
CMSEventServiceGetEventTicketSalesByEventIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "sales", kind: "message", T: cms_common_pb_1.CMSEventTicketSales, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceGetOwnedEventTicketSalesRequest
 */
class CMSEventServiceGetOwnedEventTicketSalesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceGetOwnedEventTicketSalesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceGetOwnedEventTicketSalesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceGetOwnedEventTicketSalesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceGetOwnedEventTicketSalesRequest, a, b);
    }
}
exports.CMSEventServiceGetOwnedEventTicketSalesRequest = CMSEventServiceGetOwnedEventTicketSalesRequest;
CMSEventServiceGetOwnedEventTicketSalesRequest.runtime = protobuf_1.proto3;
CMSEventServiceGetOwnedEventTicketSalesRequest.typeName = "spwn.event.v1.CMSEventServiceGetOwnedEventTicketSalesRequest";
CMSEventServiceGetOwnedEventTicketSalesRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.event.v1.CMSEventServiceGetOwnedEventTicketSalesResponse
 */
class CMSEventServiceGetOwnedEventTicketSalesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.CMSEventTicketSales sales = 1;
         */
        this.sales = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceGetOwnedEventTicketSalesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceGetOwnedEventTicketSalesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceGetOwnedEventTicketSalesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceGetOwnedEventTicketSalesResponse, a, b);
    }
}
exports.CMSEventServiceGetOwnedEventTicketSalesResponse = CMSEventServiceGetOwnedEventTicketSalesResponse;
CMSEventServiceGetOwnedEventTicketSalesResponse.runtime = protobuf_1.proto3;
CMSEventServiceGetOwnedEventTicketSalesResponse.typeName = "spwn.event.v1.CMSEventServiceGetOwnedEventTicketSalesResponse";
CMSEventServiceGetOwnedEventTicketSalesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "sales", kind: "message", T: cms_common_pb_1.CMSEventTicketSales, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceSaveEventRequest
 */
class CMSEventServiceSaveEventRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントタイトル
         *
         * @generated from field: string event_title = 2;
         */
        this.eventTitle = "";
        /**
         * イベントバナー パス
         *
         * @generated from field: string event_banner_path = 3;
         */
        this.eventBannerPath = "";
        /**
         * イベントバナー URL
         *
         * @generated from field: string event_banner_url = 4;
         */
        this.eventBannerUrl = "";
        /**
         * イベント詳細
         *
         * @generated from field: string description = 5;
         */
        this.description = "";
        /**
         * ページの公開日時
         *
         * @generated from field: int64 open = 6;
         */
        this.open = protobuf_1.protoInt64.zero;
        /**
         * 開場日時
         *
         * @generated from field: int64 part_open_time = 7;
         */
        this.partOpenTime = protobuf_1.protoInt64.zero;
        /**
         * 配信開始日時
         *
         * @generated from field: int64 part_start_time = 8;
         */
        this.partStartTime = protobuf_1.protoInt64.zero;
        /**
         * 配信終了日時
         *
         * @generated from field: int64 event_end_time = 9;
         */
        this.eventEndTime = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceSaveEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceSaveEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceSaveEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceSaveEventRequest, a, b);
    }
}
exports.CMSEventServiceSaveEventRequest = CMSEventServiceSaveEventRequest;
CMSEventServiceSaveEventRequest.runtime = protobuf_1.proto3;
CMSEventServiceSaveEventRequest.typeName = "spwn.event.v1.CMSEventServiceSaveEventRequest";
CMSEventServiceSaveEventRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_banner_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "event_banner_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "open", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "part_open_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "part_start_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "event_end_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceSaveEventResponse
 */
class CMSEventServiceSaveEventResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceSaveEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceSaveEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceSaveEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceSaveEventResponse, a, b);
    }
}
exports.CMSEventServiceSaveEventResponse = CMSEventServiceSaveEventResponse;
CMSEventServiceSaveEventResponse.runtime = protobuf_1.proto3;
CMSEventServiceSaveEventResponse.typeName = "spwn.event.v1.CMSEventServiceSaveEventResponse";
CMSEventServiceSaveEventResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "message", T: cms_common_pb_1.CMSEvent },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceDraftEventRequest
 */
class CMSEventServiceDraftEventRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * イベントタイトル
         *
         * @generated from field: string event_title = 2;
         */
        this.eventTitle = "";
        /**
         * イベントバナー パス
         *
         * @generated from field: string event_banner_path = 3;
         */
        this.eventBannerPath = "";
        /**
         * イベントバナー URL
         *
         * @generated from field: string event_banner_url = 4;
         */
        this.eventBannerUrl = "";
        /**
         * イベント詳細
         *
         * @generated from field: string description = 5;
         */
        this.description = "";
        /**
         * 開場日時
         *
         * @generated from field: int64 part_open_time = 6;
         */
        this.partOpenTime = protobuf_1.protoInt64.zero;
        /**
         * 配信開始日時
         *
         * @generated from field: int64 part_start_time = 7;
         */
        this.partStartTime = protobuf_1.protoInt64.zero;
        /**
         * 配信終了日時
         *
         * @generated from field: int64 event_end_time = 8;
         */
        this.eventEndTime = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceDraftEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceDraftEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceDraftEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceDraftEventRequest, a, b);
    }
}
exports.CMSEventServiceDraftEventRequest = CMSEventServiceDraftEventRequest;
CMSEventServiceDraftEventRequest.runtime = protobuf_1.proto3;
CMSEventServiceDraftEventRequest.typeName = "spwn.event.v1.CMSEventServiceDraftEventRequest";
CMSEventServiceDraftEventRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_banner_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "event_banner_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "part_open_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "part_start_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "event_end_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceDraftEventResponse
 */
class CMSEventServiceDraftEventResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceDraftEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceDraftEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceDraftEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceDraftEventResponse, a, b);
    }
}
exports.CMSEventServiceDraftEventResponse = CMSEventServiceDraftEventResponse;
CMSEventServiceDraftEventResponse.runtime = protobuf_1.proto3;
CMSEventServiceDraftEventResponse.typeName = "spwn.event.v1.CMSEventServiceDraftEventResponse";
CMSEventServiceDraftEventResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "message", T: cms_common_pb_1.CMSEvent },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceUpdateEventRequest
 */
class CMSEventServiceUpdateEventRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: string event_title = 2;
         */
        this.eventTitle = "";
        /**
         * @generated from field: string description = 3;
         */
        this.description = "";
        /**
         * @generated from field: string event_banner_url = 4;
         */
        this.eventBannerUrl = "";
        /**
         * @generated from field: string event_banner_path = 5;
         */
        this.eventBannerPath = "";
        /**
         * @generated from field: int64 open = 6;
         */
        this.open = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceUpdateEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceUpdateEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceUpdateEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceUpdateEventRequest, a, b);
    }
}
exports.CMSEventServiceUpdateEventRequest = CMSEventServiceUpdateEventRequest;
CMSEventServiceUpdateEventRequest.runtime = protobuf_1.proto3;
CMSEventServiceUpdateEventRequest.typeName = "spwn.event.v1.CMSEventServiceUpdateEventRequest";
CMSEventServiceUpdateEventRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "event_banner_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "event_banner_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "open", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceUpdateEventResponse
 */
class CMSEventServiceUpdateEventResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceUpdateEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceUpdateEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceUpdateEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceUpdateEventResponse, a, b);
    }
}
exports.CMSEventServiceUpdateEventResponse = CMSEventServiceUpdateEventResponse;
CMSEventServiceUpdateEventResponse.runtime = protobuf_1.proto3;
CMSEventServiceUpdateEventResponse.typeName = "spwn.event.v1.CMSEventServiceUpdateEventResponse";
CMSEventServiceUpdateEventResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "message", T: cms_common_pb_1.CMSEvent },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceGetEventRequest
 */
class CMSEventServiceGetEventRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceGetEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceGetEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceGetEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceGetEventRequest, a, b);
    }
}
exports.CMSEventServiceGetEventRequest = CMSEventServiceGetEventRequest;
CMSEventServiceGetEventRequest.runtime = protobuf_1.proto3;
CMSEventServiceGetEventRequest.typeName = "spwn.event.v1.CMSEventServiceGetEventRequest";
CMSEventServiceGetEventRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceGetEventResponse
 */
class CMSEventServiceGetEventResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceGetEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceGetEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceGetEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceGetEventResponse, a, b);
    }
}
exports.CMSEventServiceGetEventResponse = CMSEventServiceGetEventResponse;
CMSEventServiceGetEventResponse.runtime = protobuf_1.proto3;
CMSEventServiceGetEventResponse.typeName = "spwn.event.v1.CMSEventServiceGetEventResponse";
CMSEventServiceGetEventResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "message", T: cms_common_pb_1.CMSEvent },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceGetOwnedEventsRequest
 */
class CMSEventServiceGetOwnedEventsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceGetOwnedEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceGetOwnedEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceGetOwnedEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceGetOwnedEventsRequest, a, b);
    }
}
exports.CMSEventServiceGetOwnedEventsRequest = CMSEventServiceGetOwnedEventsRequest;
CMSEventServiceGetOwnedEventsRequest.runtime = protobuf_1.proto3;
CMSEventServiceGetOwnedEventsRequest.typeName = "spwn.event.v1.CMSEventServiceGetOwnedEventsRequest";
CMSEventServiceGetOwnedEventsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.event.v1.CMSEventServiceGetOwnedEventsResponse
 */
class CMSEventServiceGetOwnedEventsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.CMSEvent events = 1;
         */
        this.events = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceGetOwnedEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceGetOwnedEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceGetOwnedEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceGetOwnedEventsResponse, a, b);
    }
}
exports.CMSEventServiceGetOwnedEventsResponse = CMSEventServiceGetOwnedEventsResponse;
CMSEventServiceGetOwnedEventsResponse.runtime = protobuf_1.proto3;
CMSEventServiceGetOwnedEventsResponse.typeName = "spwn.event.v1.CMSEventServiceGetOwnedEventsResponse";
CMSEventServiceGetOwnedEventsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: cms_common_pb_1.CMSEvent, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.TicketPriority
 */
class TicketPriority extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string ticket_id = 1;
         */
        this.ticketId = "";
        /**
         * @generated from field: int32 priority = 2;
         */
        this.priority = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TicketPriority().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TicketPriority().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TicketPriority().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(TicketPriority, a, b);
    }
}
exports.TicketPriority = TicketPriority;
TicketPriority.runtime = protobuf_1.proto3;
TicketPriority.typeName = "spwn.event.v1.TicketPriority";
TicketPriority.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceUpdateEventTicketsPriorityRequest
 */
class CMSEventServiceUpdateEventTicketsPriorityRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: repeated spwn.event.v1.TicketPriority ticket_priority = 2;
         */
        this.ticketPriority = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceUpdateEventTicketsPriorityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceUpdateEventTicketsPriorityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceUpdateEventTicketsPriorityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceUpdateEventTicketsPriorityRequest, a, b);
    }
}
exports.CMSEventServiceUpdateEventTicketsPriorityRequest = CMSEventServiceUpdateEventTicketsPriorityRequest;
CMSEventServiceUpdateEventTicketsPriorityRequest.runtime = protobuf_1.proto3;
CMSEventServiceUpdateEventTicketsPriorityRequest.typeName = "spwn.event.v1.CMSEventServiceUpdateEventTicketsPriorityRequest";
CMSEventServiceUpdateEventTicketsPriorityRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_priority", kind: "message", T: TicketPriority, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.CMSEventServiceUpdateEventTicketsPriorityResponse
 */
class CMSEventServiceUpdateEventTicketsPriorityResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string ticket_id = 1;
         */
        this.ticketId = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventServiceUpdateEventTicketsPriorityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventServiceUpdateEventTicketsPriorityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventServiceUpdateEventTicketsPriorityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventServiceUpdateEventTicketsPriorityResponse, a, b);
    }
}
exports.CMSEventServiceUpdateEventTicketsPriorityResponse = CMSEventServiceUpdateEventTicketsPriorityResponse;
CMSEventServiceUpdateEventTicketsPriorityResponse.runtime = protobuf_1.proto3;
CMSEventServiceUpdateEventTicketsPriorityResponse.typeName = "spwn.event.v1.CMSEventServiceUpdateEventTicketsPriorityResponse";
CMSEventServiceUpdateEventTicketsPriorityResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
//# sourceMappingURL=cms_service_pb.js.map